<template>
<div class="fc-page ft-page"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="ft-breadcrumb"/></nav>
<header class="fc-heading"><div class="fc-child-heading"><h1>课程价格套餐</h1><p>按课程管理价格套餐与可用状态</p></div><v-btn @click="createPrice.show=true" color="#d9363e" depressed class="ft-create"><v-icon left size="18">mdi-plus</v-icon>添加套餐</v-btn></header>
<section class="fc-filters" aria-label="课程价格套餐筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查询当前校区记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell">
							<v-select v-model="query.courseId" :items="selectCourseList" label="请选择课程" item-text="courseName"
								item-value="id" outlined dense color="#d9363e" aria-label="请选择课程"></v-select>
						</div>
<div class="fc-filter-cell">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</div>
<div class="fc-filter-cell">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</div>
<div class="fc-filter-cell">
							<v-select v-model="query.status" :items="query.statusItems" item-text="text" item-value="value" label="状态" aria-label="状态" dense outlined color="#d9363e"></v-select>
						</div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><div class="fc-filter-actions"><v-btn type="submit" depressed color="#d9363e" dark :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
<section class="fc-records" aria-label="价格套餐列表"><div class="fc-list-heading"><h3>价格套餐列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table ft-table ft-course_price_list fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				<span v-if="item.status=='0'" class="fc-status fc-status-inactive">已作废</span>
				<span v-if="item.status=='1'" class="fc-status fc-status-normal">正常</span>
			</template>

			<template v-slot:item.action="{item}">

				<v-btn @click.stop="frozenPrice(item)" :disabled="item.status !== '1'" outlined color="#c93640" class="ml-2" small>作废</v-btn>
				<v-btn @click.stop="freePrice(item)" :disabled="item.status === '1'" outlined color="#c93640" class="ml-2" small>启用</v-btn>

			</template>


<template v-slot:item.courseAmount="{item}"><span class="fc-number">{{item.courseAmount}}</span></template>
<template v-slot:item.addHours="{item}"><span class="fc-number">{{item.addHours}}</span></template>
<template v-slot:item.reduceAmount="{item}"><span class="fc-number">{{item.reduceAmount}}</span></template>
<template v-slot:item.giveAmount="{item}"><span class="fc-number">{{item.giveAmount}}</span></template>
</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="7" v-model="query.page" color="#d9363e"/></div></section>
<coursePriceCreate :show="createPrice.show" @cancel="createPrice.show=false" @success="createPriceSuccess"></coursePriceCreate></div>
</template>

<script>
	import utils from "../../../config/utils"
	import coursePriceCreate from "../../../components/course_price_create.vue"
	export default {
		name: "course-price-list",
		components:{coursePriceCreate},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '课程价格套餐',
						disabled: true
					},
				],
				shopId:"",
				selectCourseList:[],
				data: {
					total: 0,
					headers: [
						{
							text: '套餐名称',
							value: 'priceName',
							sortable: false
						},
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						{
							text: '课程金额',
							value: 'courseAmount',
							sortable: false
						},
						{
							text: '课时数',
							value: 'addHours',
							sortable: false
						},
						{
							text: '直减金额',
							value: 'reduceAmount',
							sortable: false
						},
						{
							text: '赠送金额',
							value: 'giveAmount',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					courseId: "",
					status:"1",
					statusItems:[
						{value:"",text:"全部"},
						{value:"1",text:"正常"},
						{value:"0",text:"作废"},
					]
				},
				createPrice:{
					show:false
				}
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getCourseListForSelect();
			this.getTableDataList();
			
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/financial/course/price/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if(shopId){
					url += "&shopId=" + shopId;
				}
				
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.courseId) {
					url += "&courseId=" + this.query.courseId;
				}
				if(this.query.status){
					url += "&status=" + this.query.status;
				}
				
			
				this.axios.get(url).then(response => {
					
					console.log("coupon list res:",response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			createPriceSuccess(){
				this.getTableDataList();
				this.createPrice.show=false;
			},
			frozenPrice(item){
				//冻结
				const that = this;
				let url = `/financial/course/price/${item.id}/status/0`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			freePrice(item){
				//解冻
				const that = this;
				let url = `/financial/course/price/${item.id}/status/1`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getCourseListForSelect() {
				
				if (!this.shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/course/list/` + this.shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/financial-tools.scss"></style>
